

























































    import { Component, Vue ,Watch} from 'vue-property-decorator'
    import Search from "./display-container/Search.vue";
     import monthrange from './display-container/monthrange.vue';
    import Table from "./display-container/Table.vue";
    import JsonExcel from 'vue-json-excel/JsonExcel.vue';
    import VueElementLoading from 'vue-element-loading';

    import { store, StoreState,Timezone,CDR } from '../../store';
    import { mapState } from 'vuex';
    import momentTZ from 'moment-timezone';
     import XLSX from 'xlsx'; 
    import {saveAs} from 'file-saver';   
    import QuickCall from '../../components/QuickCall.vue';
   import * as moment from 'moment';  
    @Component({
        components: {
            Search,
            Table,
            JsonExcel,
            monthrange, VueElementLoading,QuickCall
        },

        computed: {
            ...mapState({
                'cdrs_callReportsHistory': (state: StoreState) => state.reports.callReportsHistory, 
                'callReports': (state: StoreState) => state.reports.callReports,
                'showLoadMoreBar': (state: StoreState) => state.reports.showLoadMoreBar,
                'timezone': (state: StoreState) => state.reports.filters.timezone,
                'showPrgress': (state: StoreState) => state.reports.callreport_Slide,
                'show_quick_call_modal': (state: StoreState) => state.dashboard.show_quick_call_modal,
                'number_to_call': (state: StoreState) => state.dashboard.number_to_call,
                searchtextclear: (state: StoreState) =>state.reports.searchtext_clear,
                bookmark: (state: StoreState) =>state.reports.bookmark,
                asc_desc: (state: StoreState) =>  state.reports.report_sort,
                'disabled': (state: StoreState) => !state.reports.currentFiltersHaveRun,
            }),

        },
        watch: {
            cdrs(newVal, oldVal) {
            //      console.log(`Watched a thing happen! assadsa`, newVal+'/'+ oldVal);
            //     this.$data.cdrs = newVal;
             //  (this.$refs.droute as any).data=newVal;
              // (this.$refs.droute as any).$el.click();
            }
        },
    
       
    })
    export default class DisplayContainer extends Vue {
        timezone!: Timezone;
        cdrs!: CDR[];
        data() {
            return {
                scrolledToBottom: true,
                isLoading:false,
                timestamp_status:true,
                fromname_statu:true,
                toname_status:true,
                duration_status:true,
                direction_status:true,
                dail_status:true,
              
                sorted_list:[],
                sort_icon:false,
                direction_defoulticon:false,
                timestamp_defoulticon:false,
                fromname_defoulticon:false,
                toname_defoulticon:false,
                duration_defoulticon:false,
                dail_defoulticon:false
            
               }
            }

        scrolltp(){
            var objDiv = document.getElementById("your_div");
            debugger
            if(objDiv!=null)
            objDiv.scrollTop =0;
        }

        defoult(name)
        {  
            this.scrolltp();
             if(name=='direction'){
               this.$data.timestamp_defoulticon=this.$data.fromname_defoulticon=this.$data.toname_defoulticon= this.$data.duration_defoulticon=this.$data.dail_defoulticon=  false;
            }     
            if(name=='timestamp'){
               this.$data.direction_defoulticon=this.$data.fromname_defoulticon= this.$data.toname_defoulticon= this.$data.duration_defoulticon=this.$data.dail_defoulticon=false;
            }
             if(name=='from_name'){
               this.$data.direction_defoulticon= this.$data.timestamp_defoulticon=this.$data.toname_defoulticon= this.$data.duration_defoulticon=this.$data.dail_defoulticon=false;
            }
            if(name=='to_name'){
               this.$data.direction_defoulticon= this.$data.timestamp_defoulticon=this.$data.fromname_defoulticon= this.$data.duration_defoulticon=this.$data.dail_defoulticon=false;
            }
            if(name=='duration'){
               this.$data.direction_defoulticon= this.$data.timestamp_defoulticon=this.$data.fromname_defoulticon= this.$data.toname_defoulticon=this.$data.dail_defoulticon=false;
            }
            if(name=='dail'){
              this.$data.direction_defoulticon= this.$data.timestamp_defoulticon=this.$data.fromname_defoulticon= this.$data.toname_defoulticon=this.$data.duration_defoulticon=false;

            }
              
        }


        Sort_By(sort_by, sort_STUS){
        
            this.$data.sort_icon=true;
            var payload={
                reporsort_Statu:true,
                sortBy   : sort_by,
                ststus   : sort_STUS// (this as any).asc_desc.asc_desc//   
                }
            this.$store.commit('SET_CALLREPORT_SORT', payload);
        }

         
        @Watch('searchtextclear')
        onChange() {
            //on run report clear input text and visible icon
            if((this as any).searchtextclear){ 
                  this.$data.scrolledToBottom=true;
                  
            }
        }

        openModal(payload) {
                this.$emit('openModal', payload);
            }


        get filteredCdrs() {
            const arg = this.$data.searchTerm;
            return (this as any).cdrs.filter(cdr => {
                if(arg !== '') {
                    return false;
                } else {
                    return true;
                }
            });
        }

        get callreport(){
            //sorting callreport
            if(store.state.reports.report_sort.sortreport_status){  
                  this.$data.sorted_list=[];
                  console.log(this.$data.sorted_list.length)
                this.$data.sorted_list=this.sory_report();
            }
            else{
                // enable defoult icon
                this.$data.direction_defoulticon=
                this.$data.timestamp_defoulticon=
                this.$data.fromname_defoulticon=
                this.$data.toname_defoulticon=
                this.$data.duration_defoulticon=
                this.$data.dail_defoulticon= 
                this.$data.sort_icon= false;

                // on load  
                this.$data.sorted_list= store.state.reports.callReports
            }
            return this.$data.sorted_list;
        }

        
        sory_report(){
            var sort_name= store.state.reports.report_sort.sort_by;
            switch (sort_name) {
                case "direction":
                    if(store.state.reports.report_sort.asc_desc){
                        store.state.reports.callReports.sort(function(a,b) {   
                        a.call_direction=a.call_direction==null?"" :  a.call_direction;
                        b.call_direction= b.call_direction==null?"": b.call_direction;
                        var x = a.call_direction.toLowerCase();
                        var y = b.call_direction.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                        });
                    }
                
                    else{
                        store.state.reports.callReports.sort(function(a,b) {   
                        a.call_direction=a.call_direction==null?"" :  a.call_direction;
                        b.call_direction= b.call_direction==null?"": b.call_direction;
                        var x = a.call_direction.toLowerCase();
                        var y = b.call_direction.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                        }).reverse();
                     
                    }
                     break;

                case "timestamp":
                    if(store.state.reports.report_sort.asc_desc){
                        store.state.reports.callReports.sort(function(a,b) {   
                        return a.timestamp - b.timestamp;
                        });
                    }
                
                    else{
                        store.state.reports.callReports.sort(function(a,b) {   
                        return a.timestamp - b.timestamp;
                        }).reverse();
                    }
                     break;


                case "from_name" :
                    if(store.state.reports.report_sort.asc_desc){
                        store.state.reports.callReports.sort(function(a,b) {   
                        var x = a.from_name.toLowerCase();
                        var y = b.from_name.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                        });
                    }
                    else{
                        store.state.reports.callReports.sort(function(a,b) {   
                        var x = a.from_name.toLowerCase();
                        var y = b.from_name.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                        }).reverse();
                    }
                    break;

                case "dail":
                    if(store.state.reports.report_sort.asc_desc){
                        store.state.reports.callReports.sort(function(a,b) {   
                        a.dialed_number=a.dialed_number==null?"":a.dialed_number;
                        b.dialed_number= b.dialed_number==null?"": b.dialed_number;
                        return a.dialed_number - b.dialed_number; 
                    });
                    }
                
                    else{
                        store.state.reports.callReports.sort(function(a,b) {   
                        a.dialed_number=a.dialed_number==null?"":a.dialed_number;
                        b.dialed_number= b.dialed_number==null?"": b.dialed_number;
                        return a.dialed_number - b.dialed_number; 
                        }).reverse();
                    }
                     break;

                case "to_name" :
                    if(store.state.reports.report_sort.asc_desc){
                        store.state.reports.callReports.sort(function(a,b) {   
                        a.to_name=a.to_name==null?"":a.to_name;
                        b.to_name= b.to_name==null?"": b.to_name;
                        var x = a.to_name.toLowerCase();
                        var y = b.to_name.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                        });
                    }
                    else{
                        store.state.reports.callReports.sort(function(a,b) {   
                        a.to_name=a.to_name==null?"":a.to_name;
                        b.to_name= b.to_name==null?"": b.to_name;
                        var x = a.to_name.toLowerCase();
                        var y = b.to_name.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                        }).reverse();
                    }
                    break;
              
                case "duration" :
                    if(store.state.reports.report_sort.asc_desc){
                        store.state.reports.callReports.sort(function(a,b) {   
                        return a.duration - b.duration; 
                        });
                    }
                    else{
                        store.state.reports.callReports.sort(function(a,b) {   
                            return a.duration - b.duration; 
                        }).reverse();
                    }
                    break;

                    default:
                    break;
            }


                return store.state.reports.callReports;
        

            
        }

        onChangePage (e) { 
              var myDiv=(this as any).$refs.report_log;
              var n= Number( myDiv.offsetHeight )+ Number (myDiv.scrollTop);
              //load data when scrollbar reach bottom
              if ( n>= Number(myDiv.scrollHeight)-10) {
                  if(this.$data.scrolledToBottom && (this as any).callReports.length!=0){
                    this.loadmoredata();
                  }
                }
            }

            loadmoredata(){  
            this.$store.commit("CALLREPORT_SLIDER", true);  
            this.$store.commit("SearchText_CLEAR",false);
            var sort_by=(this as any).sort_by==''? '': (this as any).sort_by;
             this.$store.dispatch('getCallReports', {para:{ shouldContinue: true , Page:10}}).then(r => 
             {
                 console.log((this as any).callReports.length);
                     this.$data.isLoading = false;
                     this.$data.scrolledToBottom=r.cdrs.length==0?false:true;
                     this.$store.commit("CALLREPORT_SLIDER", false);  
                }).catch(() => { 
                    this.$data.isLoading = false;
                     this.$store.commit("CALLREPORT_SLIDER", false);  
                });
             }; 


         downloadXCL() {
            if(this.callreport.length>0)
            {
            this.$data.isLoading=true;
             // this.$store.commit('UPDATE_CALL_REPORTS', { cdrs:[], total:0, monthindex:0,clear:true });
                this.$store.commit('SET_BOOKMARK', { bookmark:'' });
               this.$store.dispatch('getCallReports', {para:{ shouldContinue: false , Page:-1}}).then((r) => {
                    if(this.$store.state.reports.filters.inboundChecked 
                      || (!this.$store.state.reports.filters.inboundChecked && !this.$store.state.reports.filters.outboundChecked)) 
                      {
                        this.$store.dispatch("getVoicemails").then((r) => {  
                        
                            this.TextExcelDoc_download(); 
                            }).catch((r) => 
                            {
                            this.$data.isLoading = false;
                            }); 
                      }
                      else
                      {
                        this.TextExcelDoc_download();  
                      }
                        this.$data.isLoading = false;
                    }).catch((r) => {
                        this.$data.isLoading = false;
                    })
            } 
        }

        loadPrevious() {
            this.$store.dispatch('getCallReports', {para:{ shouldContinue: true , Page:2 }});
        }

        TextExcelDoc_download() {
			var wb = XLSX.utils.book_new();
				var data = [
                    ['Call Direction','Dialed Number','Duration','From Name'
                    ,'From Number',"ID", 'Timestamp','To Name','To Number'],
                ];
                
                var rec= this.sorted_reportDownload();//  (this as any).cdrs_callReportsHistory;  

              for(var i=0; i< rec.length; i++)  
			  {
                var durationf = function (value){
                    const duration = momentTZ.duration(+value, 'seconds');
                    return momentTZ.utc(duration.asMilliseconds()).format("mm:ss ")
                };
               
                var timestampf =function (value,tz){
                 return  momentTZ(momentTZ(value, 'x').format()).tz(tz).format('YYYY-MM-DD hh:mma');  
                }
                var timvm=function (value){
                  return  moment((value - 62167219200) * 1000).format("YYYY-MM-DD hh:mma");
                }
                 var duration= durationf(rec[i].duration);  
                 var kknlkjlk=rec[i].type;
                 debugger
                var timestamp=rec[i].type==undefined?timestampf(rec[i].timestamp,this.timezone.tz): timvm(rec[i].timestamp);// rec[i].timestamp;
               //  var timestamp= timestampf(rec[i].timestamp,this.timezone.tz);//rec[i].timestamp;;//

                data.push([rec[i].call_direction,rec[i].dialed_number,duration,rec[i].from_name
                ,rec[i].from_number,rec[i].id,timestamp,rec[i].to_name,rec[i].to_number]);
				}
			var wb = XLSX.utils.book_new();
			var ws = XLSX.utils.json_to_sheet(data, {skipHeader: true,cellDates:true});
			var range = XLSX.utils.decode_range(ws["!ref"]);
			   if(!ws['!cols']) ws['!cols'] = [];
			   if(!ws.A1.c) ws.A1.c = [];
			   var n0=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[0]? o[0].length: 5; 
                  }));
            var n1=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[1]? o[1].length: 5; 
                  }));
            var n2=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[2]? o[2].length: 5; 
                  }));
            var n3=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[3]? o[3].length: 5; 
                  }));
            var n4=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[4]? o[4].length: 5; 
                  }));
            var n5=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[5]? o[5].length: 5; 
                  }));
            var n6=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[6]? o[6].length: 5; 
                  }));
            var n7=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[7]? o[7].length: 5; 
                  }));
            var n8=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[8]? o[8].length: 5; 
                  }));
              var wscols = [{wch:n0},{wch:n1},{wch:n2},{wch:n3},{wch:n4},{wch:n5+10},{wch:n6},{wch:n7},{wch:n8}];
               ws['!cols'] = wscols;
               ws["!margins"]={left:6.0, right:8.0, top:9.0, bottom:1.0, header:0.5,footer:0.5};
		       XLSX.utils.book_append_sheet(wb, ws, "No Header");
				
			var wbout = XLSX.write(wb, {bookType:'xlsx', type:'array'});
		 saveAs(new Blob([wbout],{type:"application/octet-stream"}), "Call_Records.xlsx");
        }

         
        sorted_reportDownload(){
         
            var sort_name= store.state.reports.report_sort.sort_by;
            switch (sort_name) {
                case "direction":
                    if(store.state.reports.report_sort.asc_desc){
                       (this as any).cdrs_callReportsHistory.sort(function(a,b) {   
                        a.call_direction=a.call_direction==null?"" :  a.call_direction;
                        b.call_direction= b.call_direction==null?"": b.call_direction;
                        var x = a.call_direction.toLowerCase();
                        var y = b.call_direction.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                        });
                    }
                
                    else{
                       (this as any).cdrs_callReportsHistory.sort(function(a,b) {   
                        a.call_direction=a.call_direction==null?"" :  a.call_direction;
                        b.call_direction= b.call_direction==null?"": b.call_direction;
                        var x = a.call_direction.toLowerCase();
                        var y = b.call_direction.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                        }).reverse();
                     
                    }
                     break;

                case "timestamp":
                    if(store.state.reports.report_sort.asc_desc){
                        (this as any).cdrs_callReportsHistory.sort(function(a,b) {   
                        return a.timestamp - b.timestamp;
                        });
                    }
                
                    else{
                        (this as any).cdrs_callReportsHistory.sort(function(a,b) {   
                        return a.timestamp - b.timestamp;
                        }).reverse();
                    }
                     break;


                case "from_name" :
                    if(store.state.reports.report_sort.asc_desc){
                        (this as any).cdrs_callReportsHistory.sort(function(a,b) {   
                        var x = a.from_name.toLowerCase();
                        var y = b.from_name.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                        });
                    }
                    else{
                        (this as any).cdrs_callReportsHistory.sort(function(a,b) {   
                        var x = a.from_name.toLowerCase();
                        var y = b.from_name.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                        }).reverse();
                    }
                    break;

                case "dail":
                    if(store.state.reports.report_sort.asc_desc){
                        (this as any).cdrs_callReportsHistory.sort(function(a,b) {   
                        a.dialed_number=a.dialed_number==null?"":a.dialed_number;
                        b.dialed_number= b.dialed_number==null?"": b.dialed_number;
                        return a.dialed_number - b.dialed_number; 
                    });
                    }
                
                    else{
                        (this as any).cdrs_callReportsHistory.sort(function(a,b) {   
                        a.dialed_number=a.dialed_number==null?"":a.dialed_number;
                        b.dialed_number= b.dialed_number==null?"": b.dialed_number;
                        return a.dialed_number - b.dialed_number; 
                        }).reverse();
                    }
                     break;

                case "to_name" :
                    if(store.state.reports.report_sort.asc_desc){
                        (this as any).cdrs_callReportsHistory.sort(function(a,b) {   
                        a.to_name=a.to_name==null?"":a.to_name;
                        b.to_name= b.to_name==null?"": b.to_name;
                        var x = a.to_name.toLowerCase();
                        var y = b.to_name.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                        });
                    }
                    else{
                        (this as any).cdrs_callReportsHistory.sort(function(a,b) {   
                        a.to_name=a.to_name==null?"":a.to_name;
                        b.to_name= b.to_name==null?"": b.to_name;
                        var x = a.to_name.toLowerCase();
                        var y = b.to_name.toLowerCase();
                        return x < y ? -1 : x > y ? 1 : 0;
                        }).reverse();
                    }
                    break;
              
                case "duration" :
                    if(store.state.reports.report_sort.asc_desc){
                       (this as any).cdrs_callReportsHistory.sort(function(a,b) {   
                        return a.duration - b.duration; 
                        });
                    }
                    else{
                        (this as any).cdrs_callReportsHistory.sort(function(a,b) {   
                            return a.duration - b.duration; 
                        }).reverse();
                    }
                    break;

                    default:
                    break;
            }


                return (this as any).cdrs_callReportsHistory;
        }
      
    }
